import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useMemo,
} from "react";
import {
  Stack,
  Card,
  ChoiceList,
  Listbox,
  TextField,
  Checkbox,
  PageActions,
  FormLayout,
  Layout,
  Page,
  DropZone,
  Modal,
  Thumbnail,
  Text,
  Toast,
  List,
  InlineError,
  Select,
  Button,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { Editor } from "@tinymce/tinymce-react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axiosDefault from "axios";
import LoadingScreen from "../../Components/LoadingScreen";
import JoditEditor from "jodit-react";
import { MultiSelect } from "react-multi-select-component";

const AddEditProduct = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const [isSaving, setIsSaving] = useState(false);
  const handleChangeTitle = (value) => {
    setItem({
      ...item,
      title: value,
    });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");
  const handleChangeSubtitle = (value) => {
    setItem({ ...item, subtitle: value });
    setSubtitleError("");
  };
  const [subtitleError, setSubtitleError] = useState("");
  const handleChangeDescription = (value) => {
    setItem({ ...item, description: value });
  };
  const handleChangeText = (value) => {
    setItem({ ...item, text: value });
  };
  const handleChangeButtonText = (value) => {
    setItem({ ...item, buttonText: value });
  };
  const handleChangeScopeOfWork = (value) => {
    setItem({ ...item, scopeOfWork: value });
  };
  const handleChangeElectricalConsultant = (value) => {
    setItem({ ...item, electricalConsultant: value });
  };
  const handleChangeMechanicalConsultant = (value) => {
    setItem({ ...item, mechanicalConsultant: value });
  };
  const handleChangeLocation = (value) => {
    setItem({ ...item, location: value });
  };
  const handleChangeDate = (value) => {
    setItem({ ...item, date: value });
  };
  const handleChangeVimeoId = (value) => {
    setItem({ ...item, vimeoId: value });
  };
  const handleChangeMetaTitle = (value) => {
    setItem({ ...item, seoTitle: value });
  };
  const handleChangeMetaDescription = (value) => {
    setItem({ ...item, seoDescription: value });
  };
  const handleChangeChecked = (value) => {
    setItem({ ...item, active: value });
  };
  const handleChangeFeatured = (value) => {
    setItem({ ...item, featured: value });
  };
  const [optionsCategories, setOptionsCategories] = useState("");
  const handleSelectChangeCategory = (value) => {
    setItem({ ...item, category: value });
    setCategoryError("");
  };
  const [categoryError, setCategoryError] = useState("");

  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
    "image/webp",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload actionHint={"Accepts pdfs"} />
  );
  const uploadedFile = file && (
    <Stack>
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "product");
    form_data.append("document", file[file.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeyFile.current = result.data.data.file_key;
        fileKeyFile.current = result.data.data.file_link;
        setIsImageUploading(false);
        setItem({
          ...item,
          file: "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [file2, setFile2] = useState();
  const handleDropZoneDrop2 = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile2((file2) => acceptedFiles[0]),
    []
  );
  const fileUpload2 = !file2 && (
    <DropZone.FileUpload actionHint={"Accepts pdfs"} />
  );
  const uploadedFile2 = file2 && (
    <Stack>
      <div>
        {file2.name}{" "}
        <Text variant="bodySm" as="p">
          {file2.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendImage2 = (file2) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "product");
    form_data.append("document", file2[file2.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeyFile2.current = result.data.data.file_key;
        fileKeyFile2.current = result.data.data.file_link;
        setIsImageUploading(false);
        setItem({
          ...item,
          file2:
            "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [filesMain, setFilesMain] = useState();
  const handleDropZoneMain = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesMain((filesMain) => acceptedFiles[0]),
    []
  );
  const fileUploadMain = !filesMain && <DropZone.FileUpload />;
  const uploadedFilesMain = filesMain && (
    <Stack>
      <div className="maxtextwidth">
        {filesMain.name}{" "}
        <Text variant="bodySm" as="p">
          {filesMain.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const [imageError, setImageError] = useState("");

  const imageKey = useRef("");
  const imageKeyThumbnail = useRef("");
  const imageKeyFile = useRef("");
  const imageKeyFile2 = useRef("");
  const fileKeyFile = useRef("");
  const fileKeyFile2 = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImageMain = (filesMain) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "product");
    form_data.append("image", filesMain[filesMain.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(filesMain[filesMain.length - 1].type) > 0
              ? window.URL.createObjectURL(filesMain[filesMain.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [filesThumbnail, setFilesThumbnail] = useState();
  const handleDropZoneThumbnail = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesThumbnail((filesThumbnail) => acceptedFiles[0]),
    []
  );
  const fileUploadThumbnail = !filesThumbnail && <DropZone.FileUpload />;
  const uploadedFilesThumbnail = filesThumbnail && (
    <Stack>
      <div className="maxtextwidth">
        {filesThumbnail.name}{" "}
        <Text variant="bodySm" as="p">
          {filesThumbnail.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageThumbnail = (filesThumbnail) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "products");
    form_data.append("image", filesThumbnail[filesThumbnail.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeyThumbnail.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          thumbnail:
            validImageTypes.indexOf(
              filesThumbnail[filesThumbnail.length - 1].type
            ) > 0
              ? window.URL.createObjectURL(
                  filesThumbnail[filesThumbnail.length - 1]
                )
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [activeToast, setActiveToast] = useState(false);
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = activeToast ? (
    <Toast content={toastContent} onDismiss={toggleActiveToast} />
  ) : null;
  const [item, setItem] = useState({
    title: "",
    subtitle: "",
    text: "",
    image: "",
    active: true,
    category: "",
    buttonText: "",
    file: "",
    document: "",
    file2: "",
    document2: "",
    document1_link: "",
    document2_link: "",
  });
  const [optionsTags, setOptionsTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const editor = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseCategories = "";
    let responseTags = "";
    let responseItem = "";

    try {
      responseCategories = await axios.get(`/categories`);
      setOptionsCategories(
        responseCategories.data.data.data.map((item, index) => {
          return {
            label: item?.title?.en,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    try {
      responseTags = await axios.get(`/tags`);
      setOptionsTags(
        responseTags.data.data.data.map((item, index) => {
          return {
            label: item?.text?.en,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    if (props?.type === "edit")
      try {
        responseItem = await axios.get(`/products/${id}`);
        setItem({
          title:
            responseItem?.data?.data?.title &&
            responseItem?.data?.data?.title?.en
              ? responseItem.data.data.title.en
              : "",
          category:
            responseItem?.data?.data?.category_id !== null
              ? String(responseItem.data.data.category_id)
              : "",
          subtitle:
            responseItem?.data?.data?.subtitle &&
            responseItem?.data?.data?.subtitle?.en
              ? responseItem.data.data.subtitle.en
              : "",
          text:
            responseItem?.data?.data?.text && responseItem?.data?.data?.text?.en
              ? responseItem.data.data.text.en
              : "",
          buttonText:
            responseItem?.data?.data?.button_text &&
            responseItem?.data?.data?.button_text?.en
              ? responseItem.data.data.button_text.en
              : "",
          image: responseItem?.data?.data?.image
            ? responseItem.data.data.image
            : "",

          active: responseItem?.data?.data?.is_active ? true : false,
          file: responseItem?.data?.data?.document
            ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
            : "",
          file2: responseItem?.data?.data?.second_document
            ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
            : "",
          document: responseItem?.data?.data?.document,
          document2: responseItem?.data?.data?.second_document,
          document1_link: responseItem?.data?.data?.document_link,
          document2_link: responseItem?.data?.data?.second_document_link,
        });
        // setSelectedSubjects(
        //   responseItem?.data?.data?.subjects?.map((item, index) => {
        //     return {
        //       label: getFirstNonNullValue(item.name),
        //       value: String(item.id),
        //     };
        //   })
        // );
        setSelectedTags(
          responseItem?.data?.data?.tags?.map((item, index) => {
            return {
              label: item.text.en,
              value: String(item.id),
            };
          })
        );
        setIsSaving(false);
      } catch (error) {
        console.log(error);
      }
  }
  const [copied, setCopied] = useState(false);

  const handleCopyText = (param) => {
    console.log(param);
    navigator.clipboard
      .writeText(param)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset the copied state after 2 seconds
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Product`}
      breadcrumbs={[
        {
          onAction: () => navigate(`/admin/products`),
        },
      ]}
    >
      <FormLayout>
        <Card sectioned>
          <FormLayout>
            {/* <Checkbox
              label="Is Featured"
              checked={item.featured}
              onChange={handleChangeFeatured}
            /> */}
            <Select
              label="Category"
              options={optionsCategories}
              onChange={handleSelectChangeCategory}
              value={item.category}
              error={categoryError}
              placeholder="Please select"
            />
            <Text>Tags</Text>
            <div style={{ position: "relative", zIndex: 9999 }}>
              <MultiSelect
                options={optionsTags}
                onChange={setSelectedTags}
                value={selectedTags}
                placeholder="Please select"
              />
            </div>
            <FormLayout.Group>
              <TextField
                label="Title"
                value={item.title}
                onChange={handleChangeTitle}
                error={titleError}
              />

              <TextField
                label="Subtitle"
                value={item.subtitle}
                onChange={handleChangeSubtitle}
                error={subtitleError}
              />
              <TextField
                label="Button Text"
                value={item.buttonText}
                onChange={handleChangeButtonText}
              />
            </FormLayout.Group>
            <Text>Text</Text>
            <JoditEditor
              ref={editor}
              config={useMemo(
                () => ({
                  readonly: false,
                  placeholder: "",
                  defaultActionOnPaste: "insert_as_html",
                  defaultLineHeight: 1.5,
                  enter: "div",
                  // options that we defined in above step.
                  buttons: [
                    "bold",
                    "italic",
                    "ul",
                    "ol",
                    "hr",
                    "fullsize",
                    "table",
                    "link",
                    "align",
                  ],
                  statusbar: false,
                  sizeLG: 900,
                  sizeMD: 700,
                  sizeSM: 400,
                  toolbarAdaptive: false,
                  toolbar: true,
                }),
                []
              )}
              value={item.text}
              onChange={handleChangeText}
            />

            <FormLayout.Group>
              <FormLayout>
                <Text as="p" fontWeight="regular">
                  Image
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={item.image ? item.image : ""}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      onDrop={handleDropZoneMain}
                      onDropAccepted={sendImageMain}
                      allowMultiple={false}

                      // variableHeight
                    >
                      {uploadedFilesMain}
                      {fileUploadMain}
                    </DropZone>
                  </div>
                </div>
                <InlineError message={imageError} />

                <Text variant="bodyMd" as="p" fontWeight="regular">
                  File 1
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={item.file ? item.file : ""}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".pdf"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDrop}
                      onDropAccepted={sendImage}
                    >
                      {uploadedFile}
                      {fileUpload}
                    </DropZone>
                  </div>
                </div>
                <Button
                  size="slim"
                  onClick={() => handleCopyText(item.document1_link)}
                  disabled={!item.document1_link}
                >
                  Copy file link
                </Button>

                <Text variant="bodyMd" as="p" fontWeight="regular">
                  File 2
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={item.file2 ? item.file2 : ""}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".pdf"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDrop2}
                      onDropAccepted={sendImage2}
                    >
                      {uploadedFile2}
                      {fileUpload2}
                    </DropZone>
                  </div>
                </div>
                <Button
                  size="slim"
                  onClick={() => handleCopyText(item.document2_link)}
                  disabled={!item.document2_link}
                >
                  Copy file link
                </Button>
              </FormLayout>
              {/* <FormLayout>
                <Text as="p" fontWeight="regular">
                  Mobile Image
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={item.thumbnail ? item.thumbnail : ""}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      onDrop={handleDropZoneThumbnail}
                      onDropAccepted={sendImageThumbnail}
                      allowMultiple={false}
                      // variableHeight
                    >
                      {uploadedFilesThumbnail}
                      {fileUploadThumbnail}
                    </DropZone>
                  </div>
                </div>
              </FormLayout> */}
            </FormLayout.Group>
          </FormLayout>
        </Card>
        {/* <Card sectioned title="Search engine listing preview">
          <FormLayout>
            <Text variant="bodyMd" as="p" fontWeight="regular">
              SEO Image
            </Text>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div style={{ float: "left" }}>
                <Thumbnail
                  size="large"
                  source={item.seoImage ? item.seoImage : ""}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  marginLeft: "10px",
                }}
              >
                <DropZone
                  accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                  //   type="file"
                  allowMultiple={false}
                  onDrop={handleDropZoneDrop}
                  onDropAccepted={sendImage}
                >
                  {uploadedFile}
                  {fileUpload}
                </DropZone>
              </div>
            </div>
            <TextField
              label="Page Title"
              value={item.seoTitle}
              onChange={handleChangeMetaTitle}
            />
            <TextField
              label="Description"
              value={item.seoDescription}
              onChange={handleChangeMetaDescription}
              multiline={4}
            />
          </FormLayout>
        </Card> */}
        <FormLayout.Group condensed>
          <Card sectioned title="Visibility">
            <FormLayout>
              <Checkbox
                label="Is Active"
                checked={item.active}
                onChange={handleChangeChecked}
              />
              {/* <ChoiceList
                choices={[
                  { label: "Visible", value: "visible" },
                  { label: "Hidden", value: "hidden" },
                ]}
                selected={selected}
                onChange={handleChoiceListChange}
              /> */}

              {/* {visibilityButtonText === "Clear date" && (
                <FormLayout.Group>
                  <TextField
                    label="Visibility Date"
                    value={visibilityDateValue}
                    onChange={handleChangeVisibilityDate}
                    type="date"
                  />
                  <TextField
                    label="Visibility Time"
                    value={visibilityDateValue}
                    onChange={handleChangeVisibilityDate}
                    type="time"
                  />
                </FormLayout.Group>
              )} */}
              {/* <Button plain onClick={handleVisibilityButton}>
                {visibilityButtonText}
              </Button> */}
            </FormLayout>
          </Card>
        </FormLayout.Group>
      </FormLayout>

      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && [
            {
              content: "Delete",
              destructive: true,
              loading: isSaving && true,
              onClick: () => {
                setIsSaving(true);
                axios
                  .delete(`/products/${id}`)
                  .then((result) => {
                    navigate(`/admin/products`);
                  })
                  .catch((err) => console.log(err));
              },
            },
          ]
        }
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!item.title || item.category === "") {
      !item.title && setTitleError("This field is required");
      item.category === "" && setCategoryError("Please select a category");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.title && form_data.append("title[en]", item.title);
      form_data.append("subtitle[en]", item.subtitle);
      form_data.append("button_text[en]", item.buttonText);
      form_data.append("text[en]", item.text);
      form_data.append("is_active", item.active ? 1 : 0);
      props.type === "edit" && form_data.append("_method", "PATCH");
      imageKey.current && form_data.append("image", imageKey.current);
      imageKeyFile.current &&
        form_data.append("document", imageKeyFile.current);
      imageKeyFile2.current &&
        form_data.append("second_document", imageKeyFile2.current);
      fileKeyFile.current &&
        form_data.append("document_path", fileKeyFile.current);
      fileKeyFile2.current &&
        form_data.append("second_document_path", fileKeyFile2.current);
      form_data.append("category_id", item.category);
      selectedTags.forEach((selectedTag, index) =>
        form_data.append(`tags[${index}]`, selectedTag.value)
      );
      axios
        .post(`/products${props.type === "edit" ? `/${id}` : ""}`, form_data)
        .then((res) => {
          if (props.type === "add") {
            navigate(`/admin/products`);
          } else {
            setIsSaving(false);
            setToastContent("Changes have been saved succesffully");
            toggleActiveToast();
          }
        })
        .catch((error) => {
          // Error
          if (error.response) {
            setIsSaving(false);
            setSubtitleError(error.response.data.message);
          } else if (error.request) {
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
  }
};

export default AddEditProduct;
